import { Product } from "../product/product";
import { SubProduct } from "../subproduct/subproduct";
import { IndexExpense } from "../index-expense";
import { Category } from "../category/category";
import { CategoryDirectory } from "../directory/category";
import { ProductEditMode } from "app/components/rtb/info/class/product-edit-mode";

export class showEditMode {
    action:string;
    title:string;
    product: Product | SubProduct | ProductEditMode;
    productParent: Product;
    categori:CategoryDirectory | Category;
    settings: any;
    productId: string;
    productCategoryId: string;
    productsLen: number;
    dataId: IndexExpense;
    constructor(data) {
        this.action = data.action;
        this.title = data.title;
        this.product =  data.product;
        this.productParent =  data.productParent;
        this.categori = data.categori;
        this.settings =  data.settings;
        this.productId =  data.productId;
        this.productCategoryId =  data.productCategoryId;
        this.productsLen =  data.productsLen;
        this.dataId =  data.dataId;

    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/info-expense/show-edit-mode.ts